/**
 * The productTypeId for placeable images.
 * @const {number}
 */
export const PRODUCT_PLACEABLE_IMAGE_ID = 8;
